<template>
    <div class="sw-modal">
        <div v-click-outside="close" v-on:click="menuIndex = -1; showExistingAgents = false"
             class="sw-modal-content configure-upsell">

            <div class="row sw-modal-heading">
                <div class="col">
                    <h4><i class="fas fa-hands-helping"></i>Configure Upselling</h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <div class="row">
                    <div class="col-12 discount">
                        <p><b>Why?</b> Increase your revenue by upselling your guests to more expensive rooms that you
                            are unlikely to sell at the last minute.</p>
                        <p><b>How does it work?</b> When your upsell automation runs for a booking, we check your
                            availability and offer the guest a room upgrade - at the price difference discounted by an
                            amount you choose.</p>
                        <p>The offer(s) are sent to the guest in an email, with links labelled "Find out more" for
                            the guest to indicate their interest. When they click on a link we will notify you so that
                            you can contact the guest to close the deal. If you have no availability, no email will be
                            sent.</p>
                    </div>
                </div>
                <div class="row" v-if="!loading">
                    <div class="col-12 discount">
                        <h5><div class="form-entry__section-explanation-number">1</div> What discount will you offer on the price difference?</h5>

                        <input type="range" v-model="discount" v-on:change="configureUpselling()" min="0" max="100" step="10" list="markers">
                        <datalist id="markers">
                            <option value="10" label="0%"></option>
                            <option value="10" label="10%"></option>
                            <option value="20" label="20%"></option>
                            <option value="30" label="30%"></option>
                            <option value="40" label="40%"></option>
                            <option value="50" label="50%"></option>
                            <option value="60" label="60%"></option>
                            <option value="70" label="70%"></option>
                            <option value="80" label="80%"></option>
                            <option value="90" label="90%"></option>
                            <option value="100" label="100%"></option>
                        </datalist>
                    </div>
                </div>
                <div class="row" v-if="establishment && !loading">
                    <div class="col-12">
                        <h5><div class="form-entry__section-explanation-number">2</div>Map your room types for upselling</h5>
                        <div class="matrix-container">
                            <table class="upsell-matrix">
                                <thead>
                                    <th class="markdown-syntax__hdr-element"></th>
                                    <th class="markdown-syntax__hdr-element text-center upsell-matrix__header-to__level-1"
                                        v-bind:colspan="roomTypeMappings.length">
                                        Upsell To
                                    </th>
                                </thead>
                                <thead>
                                    <th class="markdown-syntax__hdr-element"></th>
                                    <th v-for="(roomTypeNameTo, indexNameTo) in roomTypeMappings"
                                        v-bind:key="indexNameTo"
                                        class="markdown-syntax__hdr-element text-center upsell-matrix__header-to__level-2">
                                        {{roomTypeNameTo.name}}
                                    </th>
                                </thead>
                                <tr v-for="(roomTypeFrom, indexFrom) in roomTypeMappings" v-bind:key="indexFrom">
                                    <td class="upsell-matrix__from">
                                        <span>{{roomTypeFrom.name}}</span>
                                        <span><i class="fas fa-arrow-right"></i></span>
                                    </td>
                                    <td v-for="(roomTypeTo, indexTo) in roomTypeMappings" v-bind:key="indexTo"
                                        class="text-center">
                                        <template v-if="roomTypeFrom.upsellMappings && roomTypeFrom.externalId !== roomTypeTo.externalId">
                                            <input type="checkbox"
                                                   v-model="roomTypeFrom.upsellMappings[roomTypeTo.reference]"
                                                   v-on:click="toggleUpsell(roomTypeFrom.reference, roomTypeTo.reference)">
                                        </template>
                                        <template v-else>
                                            -
                                        </template>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <p><b>Note:</b> This is a 2 step process. After you have configured your upsell mappings here, you
                                need to create an Automation that sends an upsell email to the guest.</p>
                        </div>
                    </div>
                </div>

            </div>
            <div class="sw-modal-actions">
                <div v-if="waiting || loading">
                    <Spinner/>
                </div>
                <div v-else class="row">
                    <div v-if="error" class="col-12">
                        <div class="alert alert-danger" role="alert">
                            {{error}}
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" v-on:click="close">Close</button>
                    </div>
                </div>
            </div>
        </div>

<!--        <confirm-dialog v-bind:message="confirmDeleteMessage" v-bind:callbackPrimaryName="'delete-agent'"-->
<!--                        v-bind:callbackPrimaryReference="editingAgent.reference" v-if="showConfirmDeleteAgent"/>-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { store } from '../../store.js'
    // import ConfirmDialog from '../ConfirmDialog.vue'
    import Spinner from '../Spinner.vue'
    // import {ValidationObserver, ValidationProvider} from 'vee-validate'
    // import Tooltip from '../Tooltip'

    const MIN_DISCOUNT = 20;

    export default {
        name: 'ConfigureUpSell',
        components: {
            Spinner
        },
        props: {
            establishment: Object
        },
        data: function () {
            return {
                discount: 50,
                roomTypeMappings: [],
                loading: true,
                waiting: false,
                infoMessage: null,
                success: null,
                error: null,
            }
        },
        computed: {
        },
        methods: {
            getUpsellConfiguration: async function() {
                this.error = false;

                try {
                    const response = await this.$http.get('/guest-management/v1/establishments/' + this.establishment.reference + '/upsell/configuration');
                    this.discount = response.data.discount;
                } catch(error) {
                    this.error = true;
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                    return false;
                }
            },
            configureUpselling: async function() {
                if (this.discount < MIN_DISCOUNT) {
                    this.discount = MIN_DISCOUNT;
                    return;
                }

                this.waiting = true;
                this.error = false;
                const body = {
                    discount: this.discount
                };
                this.$http.put('/guest-management/v1/establishments/' + this.establishment.reference + '/upsell/configuration', body
                ).then(() => {
                    return true;
                }).catch(error => {
                    this.error = true;
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                    return false;
                }).finally(() => {
                    this.waiting = false;
                });
            },
            fetchUpsellMappings: async function () {
                this.waiting = true;
                this.error = null;

                try {
                    const response = await this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/upsell/mappings', {
                        withCredentials: true
                    });
                    // console.log(response);
                    let mappings = response.data.mappings;
                    for (let roomType of this.roomTypeMappings) {
                        console.log("checking for mappings for " + roomType.reference);
                        let mappingList = mappings['' + roomType.reference +'']
                        if (mappingList) {
                            console.log(mappingList);
                            for (let toMapping of mappingList) {
                                // Vue.set(roomType.upsellMappings, toMapping, true);
                                roomType.upsellMappings[toMapping] = true;
                            }
                        }
                    }
                } catch (error) {
                    console.log(error);
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "An unknown error occurred while trying to fetch room type upsell mappings"
                    }
                } finally {
                    console.log("Finished");
                    this.waiting = false;
                }
            },
            createUpsellOnServer: async function(fromReference, toReference) {
                this.waiting = true;
                this.error = false;
                console.log("Create upsell from: " + fromReference + " to: " + toReference);
                this.$http.put('/guest-management/v1/establishments/' + this.establishment.reference + '/upsell/mappings/from/' + fromReference + "/to/" + toReference
                ).then(() => {
                    return true;
                }).catch(error => {
                    this.error = true;
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                    return false;
                }).finally(() => {
                    this.waiting = false;
                });
            },
            deleteUpsellOnServer: async function(fromReference, toReference) {
                this.waiting = true;
                this.error = false;

                console.log("Delete upsell from: " + fromReference + " to: " + toReference);
                this.$http.delete('/guest-management/v1/establishments/' + this.establishment.reference + '/upsell/mappings/from/' + fromReference + "/to/" + toReference
                ).then(() => {
                    return true;
                }).catch(error => {
                    this.error = true;
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                    return false;
                }).finally(() => {
                    this.waiting = false;
                });
            },
            toggleUpsell: async function(fromReference, toReference) {
                for (let roomType of this.roomTypeMappings) {
                    if (roomType.reference === fromReference) {
                        if (roomType.upsellMappings[toReference]) {
                            if (await this.deleteUpsellOnServer(fromReference, toReference)) {
                                roomType.upsellMappings[toReference] = false;
                            }
                        } else {
                            if (await this.createUpsellOnServer(fromReference, toReference)) {
                                roomType.upsellMappings[toReference] = true;
                            }
                        }
                        return;
                    }
                }
            },
            close: function () {
                console.log("close edit Agents");
                console.log(this.editingAgent);
                this.$root.$emit('finished-editing-upsell');
            },
        },
        mounted: async function () {
            if (this.establishment) {
                for (let roomType of this.establishment.roomTypes) {
                    let roomTypeWithMappings = Object.assign({}, roomType);
                    Vue.set(roomTypeWithMappings, 'upsellMappings', {});
                    this.roomTypeMappings.push(roomTypeWithMappings);
                }
            }
            await Promise.all([
                await this.getUpsellConfiguration(),
                await this.fetchUpsellMappings(),
            ]);
            this.loading = false;
        },
        beforeDestroy () {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/layout/forms";
    @import "../../styles/components/modal";
    @import "../../styles/pages/edit-form";
    @import "../../styles/components/edit_form_component";
    @import "../../styles/components/configure_upsell";
    @import "../../styles/components/question_answer.scss";
</style>
